import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Redirect } from 'react-router-dom';

import SortableTree from 'react-sortable-tree';
import 'react-sortable-tree/style.css'; // This only needs to be imported once in your app

import uniqid from 'uniqid';

import { api_crud_base, api_crud_route, data_interface, endpoints } from './Config';

import { getTokenInfo } from '../../../../UseToken';

import Loader from '../../../Loader/Loader';

import Swal from 'sweetalert2'

import { language } from './Language';
import { icon } from '../../../WEBContent/Icon';

import {
	reqGET,
	reqPOST,
	reqDELETE,
	reqPUT,
	reqFILE,
	content_language,
	translate,
	functionSendMail,
} from '../../../../Utils';

import Hosts, { companycode } from '../../../../Hosts';
import { set } from 'core-js/core/dict';

export default function Regist(props) {
	const [, set_dados] = useState(null);
	const dados = useRef(null);

	const entities_list = useRef(null);
	const entities_list_external = useRef(null);

	const active = useRef(null);
	const active_raw = useRef(null);
	const repair_type = useRef(null);
	const periodicity = useRef(null);
	const priority = useRef(null);

	{ console.log('DADOS', dados) }
	{ console.log('ENTITIES_LIST', entities_list_external) }

	const [lang, set_lang] = useState('pt');
	const [uid,] = useState(uniqid());

	const [isloading, setLoading] = useState(true);
	const [isRedirect, setRedirect] = useState(false);
	const [refresh, setRefresh] = useState(0);

	const [show_delete_button, set_show_delete_button] = useState(false);

	//const [disabled, set_disabled] = useState(true)

	const [is_edit, set_is_edit] = useState(false)
	const [treeDataPDF, setTreeDataPDF] = useState([])
	const [treeDataEditable, setTreeDataEditable] = useState([])

	const [files_doc_pdf, set_files_doc_pdf] = useState([]);
	const [files_doc_pdf_name, set_files_doc_pdf_name] = useState([]);
	const [files_doc_editable, set_files_doc_editable] = useState([]);
	const [files_doc_editable_name, set_files_doc_editable_name] = useState([]);

	const [treeDataImage, setTreeDataImage] = useState([])
	const [files_doc_image, set_files_doc_image] = useState([]);
	const [files_doc_image_name, set_files_doc_image_name] = useState([]);

	const [notify_responsable_edit, set_notify_responsable_edit] = useState(false)
	const [notify_responsable_aproval, set_notify_responsable_aproval] = useState(false)
	const [notify_responsable_remove, set_notify_responsable_remove] = useState(false)

	const [document_state_list, set_document_state_list] = useState([])
	const [document_state_aprove, set_document_state_aprove] = useState(false)

	const [manutencao, setManutencao] = useState(null); //TRUE = 'Manutenção', FALSE = 'Reparação', NULL = 'Nenhum'
	const [externalIntervention, setExternalIntervention] = useState('');
	const [selectedEquipment, setSelectedEquipment] = useState(null);

	useEffect(() => {
		if (dados.current) {
			setSelectedEquipment(dados.current);
		}
	}, [dados.current]);

	function parseCost(cost) {
		if (!cost) return 0;

		const normalized = String(cost)
			.replace(/[^\d.,]/g, '')
			.replace(',', '.');

		const parsed = parseFloat(normalized);
		return isNaN(parsed) ? 0 : parsed;
	}

	useEffect(() => {

	}, [dados, active]);

	const add_action = () => {
		if (dados.current.info.action === undefined) {
			dados.current.info.action = []
		}

		set_dados(dados.current.info.action.push({}))
	}

	const change_action = (e) => {
		const { name, value, dataset } = e.target;
		const { order } = dataset

		if (dados.current.info.action === undefined) {
			dados.current.info.action = []
		} if (dados.current.info.action[order] === undefined && dados.current.info.action[order] === null) {
			dados.current.info.action[order] = {}
		}

		if (dados.current.info.action[order] !== undefined && dados.current.info.action[order] !== null) {

			if (name === 'responsavel') {
				let aux_entity = entities_list.current.filter(el => parseInt(el.id) === parseInt(value))
				let aux = {
					id: value,
					name: '',
					notification: '',
					execution: ''
				}
				if (Array.isArray(aux_entity) && aux_entity.length > 0) {
					console.log(aux_entity[0])
					aux.name = aux_entity[0].label
				}

				set_dados(dados.current.info.action[order][name] = aux)
			}
			else {
				set_dados(dados.current.info.action[order][name] = value)
			}

			setRefresh(r => r + 1)

		}

		console.log('dados.current.info.action', dados.current.info.action)

	}

	const add_utilities = () => {
		if (!Array.isArray(dados.current.info.utilities)) {
			dados.current.info.utilities = [];
		}

		dados.current.info.utilities.push({});
		set_dados({ ...dados });
	};

	const change_utilities = (e) => {
		const { name, value, dataset } = e.target;
		const order = parseInt(dataset.order);

		if (!Array.isArray(dados.current.info.utilities)) {
			dados.current.info.utilities = [];
		}

		if (!dados.current.info.utilities[order]) {
			dados.current.info.utilities[order] = {};
		}

		if (name === 'fornecedor') {
			const aux_entity = entities_list_external.current?.filter(el => parseInt(el.id) === parseInt(value)) || [];
			let aux = {
				id: value,
				name: '',
				notification: '',
				execution: ''
			};

			if (aux_entity.length > 0) {
				aux.name = aux_entity[0].label;
			}

			dados.current.info.utilities[order][name] = aux;
		} else {
			dados.current.info.utilities[order][name] = value;
		}

		set_dados({ ...dados });
		setRefresh(r => r + 1);

		console.log('dados.current.info.utilities', dados.current.info.utilities);
	};

	const add_service = () => {
		if (!Array.isArray(dados.current.info.service)) {
			dados.current.info.service = [];
		}

		dados.current.info.service.push({});
		set_dados({ ...dados });
	};

	const change_service = (e) => {
		const { name, value, dataset } = e.target;
		const order = parseInt(dataset.order);

		if (!Array.isArray(dados.current.info.service)) {
			dados.current.info.service = [];
		}

		if (!dados.current.info.service[order]) {
			dados.current.info.service[order] = {};
		}

		if (name === 'fornecedor') {
			const aux_entity = entities_list_external.current?.filter(el => parseInt(el.id) === parseInt(value)) || [];
			let aux = {
				id: value,
				name: '',
				notification: '',
				execution: ''
			};

			if (aux_entity.length > 0) {
				aux.name = aux_entity[0].label;
			}

			dados.current.info.service[order][name] = aux;
		} else {
			dados.current.info.service[order][name] = value;
		}

		set_dados({ ...dados });
		setRefresh(r => r + 1);

		console.log('dados.current.info.service', dados.current.info.service);
	};

	const clean_data = () => {
		// DEEP COPY OF data_interface 
		set_dados(dados.current = JSON.parse(JSON.stringify(data_interface)))
		set_dados(dados.current.info.companycode = getTokenInfo().companycode)
		//console.log(dados.current)
	}

	const fetch_entities_list = async (type) => {

		let res = await reqGET(`${api_crud_base}/entities/list/${getTokenInfo().companycode}/*`)
		let result = []

		if (res.data !== undefined) {
			result = res.data.filter(el => parseInt(el.entity_type) === parseInt(type))
		}

		return result

	}

	const fetch_maintenance_actives = async (type) => {

		let res = await reqGET(`${api_crud_base}/intranet/maintenance/type/${getTokenInfo().companycode}/${type}`)
		let result = []
		if (res.data !== undefined) {
			for await (let el of res.data) {
				console.log('ELEMENT', el)
				let aux = {
					id: el.id,
					name: translate(el.info.title, 'pt'),

					cod: el.info.tag,
					brand: el.info.settings.storage_brand,
					model: el.info.settings.storage_model,
					serie: el.info.settings.storage_serie,
					local: el.info.settings.storage_local,
				}
				console.log('aux', aux)
				result.push(aux)
			}
		}

		return result

	}

	const order_array = (array) => {

		return array.sort((a, b) => {
			const nameA = a.name.toUpperCase(); // ignore upper and lowercase
			const nameB = b.name.toUpperCase(); // ignore upper and lowercase
			if (nameA < nameB) {
				return -1;
			}
			if (nameA > nameB) {
				return 1;
			}

			// names must be equal
			return 0;
		});

	}

	useEffect(() => {
		clean_data();

		set_lang(localStorage.getItem('lang'))

		set_dados(entities_list.current = [])
		set_dados(active.current = [])

		let aux_document_state = [
			{
				id: 0,
				label: 'Em edição'
			},
			{
				id: 1,
				label: 'Aguarda aprovação'
			},
			{
				id: 2,
				label: 'Em revisão'
			},
			{
				id: 3,
				label: 'Aprovado'
			},
			{
				id: 4,
				label: 'Obsoleto'
			},
			{
				id: 5,
				label: 'Eliminado'
			}
		]
		set_document_state_list(aux_document_state)

		const fetch_maintenance_attributes = async (type) => {

			let res = await reqGET(`${api_crud_base}/intranet/maintenance/attribute/type/${getTokenInfo().companycode}/${type}`)
			let result = []
			if (res.data !== undefined) {
				for await (let el of res.data) {

					let aux = {
						id: el.id,
						name: translate(el.info.title, 'pt')
					}

					result.push(aux)
				}
			}

			return result

		}

		const get_attr = async () => {
			let res_1 = await fetch_maintenance_actives('active')
			if (res_1.length > 0) {
				res_1 = order_array(res_1)

				let res_aux_1 = []
				for await (let el of res_1) {
					res_aux_1.push({
						id: el.id,
						label: el.name,
					})
				}
				set_dados(active.current = res_aux_1)
				set_dados(active_raw.current = res_1)
			}

			let res_2 = await fetch_maintenance_attributes('repair_type')
			if (res_2.length > 0) {
				res_2 = order_array(res_2)

				let res_aux_2 = []
				for await (let el of res_2) {
					res_aux_2.push({
						id: el.id,
						label: el.name,
					})
				}
				set_dados(repair_type.current = res_aux_2)
			}

			let res_3 = await fetch_maintenance_attributes('periodicity')
			if (res_3.length > 0) {
				res_3 = order_array(res_3)

				let res_aux_3 = []
				for await (let el of res_3) {
					res_aux_3.push({
						id: el.id,
						label: el.name,
					})
				}
				set_dados(periodicity.current = res_aux_3)
			}

			let res_4 = await fetch_entities_list(1)
			if (res_4.length > 0) {
				res_4 = order_array(res_4)

				let res_aux_4 = []
				for await (let el of res_4) {
					res_aux_4.push({
						id: el.id,
						label: el.name,
						email: el.email
					})
				}
				set_dados(entities_list.current = res_aux_4)
			}

			let res_5 = await fetch_maintenance_attributes('priority')
			if (res_5.length > 0) {
				res_5 = order_array(res_5)

				let res_aux_5 = []
				for await (let el of res_5) {
					res_aux_5.push({
						id: el.id,
						label: el.name,
					})
				}
				set_dados(priority.current = res_aux_5)
			}

			let res_6 = await fetch_entities_list(2);
			if (res_6.length > 0) {
				res_6 = order_array(res_6);

				let res_aux_6 = [];
				for await (let el of res_6) {
					if (parseInt(el.relacao) === 10) {
						res_aux_6.push({ ...el });
					}
				}

				set_dados(entities_list_external.current = res_aux_6);
			}

			setLoading(false);

			return true

		}

		const fetch_id_info = async (id_serch) => {

			try {

				await get_attr()

				let res = await reqGET(`${api_crud_route}/${companycode}/${id_serch}`)

				if (Array.isArray(res.data) && res.data.length > 0) {
					set_dados(dados.current = res.data[0]);
					setSelectedEquipment(res.data[0]);

					if (res.data[0]?.info?.file?.pdf !== undefined && Array.isArray(res.data[0].info.file.pdf)) {
						let aux_doc_pdf = []
						let i = 0

						for await (let el of res.data[0].info.file.pdf) {
							if (aux_doc_pdf[0] === undefined)
								aux_doc_pdf[0] = []
							if (aux_doc_pdf[0][1] === undefined)
								aux_doc_pdf[0][1] = []

							// aux_doc_pdf[0][1].push({ id: ++i, id_doc: el.id, title: el.name, link: el.link, visible: el.visible })
							aux_doc_pdf[0][1][0] = { id: ++i, id_doc: el.id, title: el.name, link: el.link, visible: el.visible }
						}
						setTreeDataPDF(aux_doc_pdf)
					}
					if (res.data[0]?.info?.file?.editable !== undefined && Array.isArray(res.data[0].info.file.editable)) {
						let aux_doc_editable = []
						let i = 0

						for await (let el of res.data[0].info.file.editable) {
							if (aux_doc_editable[0] === undefined)
								aux_doc_editable[0] = []
							if (aux_doc_editable[0][1] === undefined)
								aux_doc_editable[0][1] = []

							// aux_doc_editable[0][1].push({ id: ++i, id_doc: el.id, title: el.name, link: el.link, visible: el.visible })
							aux_doc_editable[0][1][0] = { id: ++i, id_doc: el.id, title: el.name, link: el.link, visible: el.visible }
						}
						setTreeDataEditable(aux_doc_editable)
					}
					console.log('res.data[0].info.file', res.data[0].info.file)
					if (res.data[0]?.info?.file?.file_image !== undefined && Array.isArray(res.data[0].info.file.file_image)) {
						let aux_doc_image = []
						let i = 0

						for await (let el of res.data[0].info.file.file_image) {
							if (aux_doc_image[0] === undefined)
								aux_doc_image[0] = []
							if (aux_doc_image[0][1] === undefined)
								aux_doc_image[0][1] = []

							aux_doc_image[0][1].push({ id: ++i, id_doc: el.id, title: el.name, link: el.link, visible: el.visible })
							// aux_doc_image[0][1][0] = { id: ++i, id_doc: el.id, title: el.name, link: el.link, visible: el.visible }
						}
						setTreeDataImage(aux_doc_image)
					}

					setRefresh(r => r + 1);

				}

				set_is_edit(true)


			} catch (error) {
				console.error("Erro:", error);
			}
		}

		try {
			let test = props.location.state.operation;

			if (test === 'edit') {
				fetch_id_info(props.location.state.item.id)
			}
			else {
				get_attr()
			}

		} catch {
			clean_data()

			get_attr()

			return
		}

	}, [props, active_raw]);

	const handleSubmit = async e => {
		e.preventDefault();

		let today = new Date();
		let today_aux = String(today.getDate()).padStart(2, '0') + '-' + String(today.getMonth() + 1).padStart(2, '0') + '-' + today.getFullYear();


		if (!selectedEquipment) {
			alert("Selecione um equipamento antes de submeter.");
			return;
		}

		dados.current.info.active = {
			id_intervention: selectedEquipment.id,
			id_active: selectedEquipment.info.equipment.id,
			name: selectedEquipment.info.equipment.name,
			cod: selectedEquipment.info.equipment.cod,
			brand: selectedEquipment.info.equipment.brand,
			model: selectedEquipment.info.equipment.model,
			serie: selectedEquipment.info.equipment.serie,
			local: selectedEquipment.info.equipment.local,
		};

		dados.current.info.action = selectedEquipment?.info?.action || [];
		dados.current.info.service = selectedEquipment?.info?.service || [];
		dados.current.info.utilities = selectedEquipment?.info?.utilities || [];

		dados.current.info.subtotals = {
			action: (selectedEquipment?.info?.action || []).reduce((acc, item) => acc + parseCost(item.cost), 0),
			service: (selectedEquipment?.info?.service || []).reduce((acc, item) => acc + parseCost(item.cost), 0),
			utilities: (selectedEquipment?.info?.utilities || []).reduce((acc, item) => acc + parseCost(item.cost), 0),
		};

		dados.current.info.total = (
			dados.current.info.subtotals.action +
			dados.current.info.subtotals.service +
			dados.current.info.subtotals.utilities
		).toFixed(2);

		if (is_edit === true) {

			await Swal.fire({
				title: language[lang].edit_title,
				text: language[lang].edit_text,
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: '#0095e8',
				cancelButtonColor: '#d9214e',
				confirmButtonText: language[lang].edit_confirm,
				cancelButtonText: language[lang].edit_cancel
			})
				.then(async (result) => {
					if (result.isConfirmed) {
						if (document_state_aprove) {
							dados.current.info.settings.document_state = "3"

							dados.current.info.responsable.aproval.execution = today
							dados.current.info.historic[dados.current.info.historic.length - 1].aproval.date = today
						}

						if (notify_responsable_edit) {
							if (dados.current.info.responsable.edit.id !== '') {
								let aux_id = dados.current.info.responsable.edit.id
								let aux_responsable = entities_list.current.filter(e => parseInt(e.id) === parseInt(aux_id))

								dados.current.info.responsable.edit.notification = today
								dados.current.info.responsable.edit.execution = today

								if (dados.current.info.historic === undefined || dados.current.info.historic === null) {
									dados.current.info.historic = []
								}

								if (Array.isArray(dados.current.info.historic) && dados.current.info.historic.length === 0) {
									dados.current.info.historic.push({
										edit: {
											id: aux_responsable[0].id,
											name: aux_responsable[0].label,
											date: today
										},
										aproval: {
											id: '',
											name: '',
											date: ''
										}
									})

									dados.current.info.responsable.aproval.id = ''
									dados.current.info.responsable.aproval.name = ''
									dados.current.info.responsable.aproval.notification = ''
									dados.current.info.responsable.aproval.execution = ''
								}
								else {
									let aux = dados.current.info.historic[dados.current.info.historic.length - 1]

									if (aux?.aproval?.id === '' || (aux?.aproval?.date !== undefined && aux?.aproval?.date === '')) {
										dados.current.info.historic[dados.current.info.historic.length - 1].edit.id = aux_responsable[0].id
										dados.current.info.historic[dados.current.info.historic.length - 1].edit.name = aux_responsable[0].label
										dados.current.info.historic[dados.current.info.historic.length - 1].edit.date = today
									}
									else {
										dados.current.info.historic.push({
											edit: {
												id: aux_responsable[0].id,
												name: aux_responsable[0].label,
												date: today
											},
											aproval: {
												id: '',
												name: '',
												date: ''
											}
										})

										dados.current.info.settings.document_state = "1"

										dados.current.info.responsable.aproval.id = ''
										dados.current.info.responsable.aproval.name = ''
										dados.current.info.responsable.aproval.notification = ''
										dados.current.info.responsable.aproval.execution = ''
									}
								}
							}
						}

						if (notify_responsable_aproval) {
							if (dados.current.info.responsable.aproval.id !== '') {
								let aux_id = dados.current.info.responsable.aproval.id
								let aux_responsable = entities_list.current.filter(e => parseInt(e.id) === parseInt(aux_id))

								dados.current.info.responsable.aproval.notification = today

								if (Array.isArray(dados.current.info.historic) && dados.current.info.historic.length > 0) {
									let aux = dados.current.info.historic[dados.current.info.historic.length - 1]

									dados.current.info.historic[dados.current.info.historic.length - 1].aproval.id = aux_responsable[0].id
									dados.current.info.historic[dados.current.info.historic.length - 1].aproval.name = aux_responsable[0].label
									dados.current.info.historic[dados.current.info.historic.length - 1].aproval.date = ''

								}
							}
						}

						if (notify_responsable_remove) {
							if (dados.current.info.responsable.remove.id !== '') {

								dados.current.info.responsable.remove.notification = today
								dados.current.info.responsable.remove.execution = today

							}

						}

						for await (let el_doc of files_doc_pdf) {
							if (el_doc !== null) {
								await uploadFilesDoc(el_doc.files, el_doc.order, 'pdf', el_doc.langid, el_doc.lang)
							}
						}
						set_files_doc_pdf([])
						set_files_doc_pdf_name([])

						for await (let el_doc of files_doc_editable) {
							if (el_doc !== null) {
								await uploadFilesDoc(el_doc.files, el_doc.order, 'editable', el_doc.langid, el_doc.lang)
							}
						}

						set_files_doc_editable([])
						set_files_doc_editable_name([])

						for await (let el_doc of files_doc_image) {
							if (el_doc !== null) {
								await uploadFilesDoc(el_doc.files, el_doc.order, 'file_image', el_doc.langid, el_doc.lang)
							}
						}
						set_files_doc_image([])
						set_files_doc_image_name([])

						console.log('HANDLE_SUBMIT dados.current', dados.current)

						await reqPUT(api_crud_route, dados.current)
							.then(async () => {
								if (notify_responsable_edit) {

								}
								if (notify_responsable_aproval) {
									if (dados.current.info.responsable.aproval.id !== '') {

										let aux_id = dados.current.info.responsable.aproval.id
										let aux_responsable = entities_list.current.filter(e => parseInt(e.id) === parseInt(aux_id))

										if (Array.isArray(aux_responsable) && aux_responsable.length > 0) {

											let aux = {
												id: dados.current.id,
												uniqid: dados.current.info.uniqid,
												companycode: dados.current.info.companycode,

												type: 'maintenance',
												title: translate(dados.current.info.title, lang),
												description: translate(dados.current.info.description, lang),
												responsaveis: [{
													value: aux_responsable[0].id
												}],
												state_object: {
													value: 1,
													labelEn: "Pending approval",
													labelPt: "Pendente de aprovação"
												},
												deadline: '',
											}

											reqPOST(`${Hosts.SIMCore_API}/entities/notification/new`, aux)

											return

											let mail_content = '<table width="600" cellpadding="0" cellspacing="0" border="0" align="0" class="0" style="width: 600px; height: 90px; padding: 15px 30px; background-color:' + Hosts.EMAIL_BACKGROUND_COLOR + '; border:1px solid transparent; border-collapse:collapse;">' +
												'<tr style="border-collapse: collapse;">' +
												'<td align="left" style="padding: 30px 40px 0px; font-family:poppins, helvetica, arial, sans-serif; font-size:' + Hosts.EMAIL_TEXT_SIZE + '; line-height:' + Hosts.EMAIL_TEXT_LINE_HEIGHT + '; color:' + Hosts.EMAIL_TEXT_COLOR + '">' +
												'<div>' +
												'<span><b>' + language[lang].notification_aproval_subject + '</b></span>' +
												'</div>' +
												'</td>' +
												'<td align="right" style="padding: 30px 40px 0px; font-family:poppins, helvetica, arial, sans-serif; font-size:' + Hosts.EMAIL_TEXT_SIZE + '; line-height:' + Hosts.EMAIL_TEXT_LINE_HEIGHT + '; color:' + Hosts.EMAIL_TEXT_COLOR + '">' +
												'<div>' +
												'<span>' + today_aux + '</span>' +
												'</div>' +
												'</td>' +
												'</tr>' +

												'<tr>' +
												'<td colspan="2" align="right" style="padding: 0px 40px; height: 15px;"></td>' +
												'</tr>' +

												'<tr style="border-collapse: collapse;">' +
												'<td colspan="2" align="left" style="padding:40px; border-collapse:collapse; font-family:poppins, helvetica, arial, sans-serif; font-size:' + Hosts.EMAIL_TEXT_SIZE + '; line-height:' + Hosts.EMAIL_TEXT_LINE_HEIGHT + '; color:' + Hosts.EMAIL_TEXT_COLOR + '">' +
												'<div>' +
												'<br/>' +
												'<span>' + language[lang].notification_aproval_text + '</span>' +
												'<br/>' +
												'</div>' +
												'</td>' +
												'</tr>' +
												'</table>'

											// let sendFrom = 'web.dev@assec.pt'
											// let sendTo = ['web.teste@assec.pt']
											// let sendToCC = ['web.dev@assec.pt']
											// let subject = language[lang].notification_aproval_subject
											// let content = mail_content
											// let attachment = []

											// await functionSendMail(sendFrom, sendTo, sendToCC, subject, content, attachment)
										}

									}
								}
								if (notify_responsable_remove) {
									if (dados.current.info.responsable.remove.id !== '') {
										// let aux_id = dados.current.info.responsable.remove.id
										// let aux_responsable = entities_list.current.filter(e => parseInt(e.id) === parseInt(aux_id))

										// console.log('remove aux_responsable', aux_responsable)
										dados.current.info.responsable.remove.notification = today
									}
								}

							})
							.catch(() => Swal.fire(language[lang].edit_error, '', 'info'))
					}
				})

		}
		else {

			await Swal.fire({
				title: language[lang].insert_title,
				text: language[lang].insert_text,
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: '#0095e8',
				cancelButtonColor: '#d9214e',
				confirmButtonText: language[lang].insert_confirm,
				cancelButtonText: language[lang].insert_cancel
			})
				.then(async (result) => {
					if (result.isConfirmed) {
						dados.current.info['uniqid'] = uid

						if (notify_responsable_edit) {
							if (dados.current.info.responsable.edit.id !== '') {
								let aux_id = dados.current.info.responsable.edit.id
								let aux_responsable = entities_list.current.filter(e => parseInt(e.id) === parseInt(aux_id))

								dados.current.info.responsable.edit.notification = today
								dados.current.info.responsable.edit.execution = today

								if (dados.current.info.historic === undefined || dados.current.info.historic === null) {
									dados.current.info.historic = []
								}

								if (Array.isArray(dados.current.info.historic) && dados.current.info.historic.length === 0) {
									dados.current.info.historic.push({
										edit: {
											id: aux_responsable[0].id,
											name: aux_responsable[0].label,
											date: today
										},
										aproval: {
											id: '',
											name: '',
											date: ''
										}
									})

									// dados.current.info.responsable.aproval.id = ''
									// dados.current.info.responsable.aproval.name = ''
									// dados.current.info.responsable.aproval.notification = ''
									// dados.current.info.responsable.aproval.execution = ''
								}
								else {
									let aux = dados.current.info.historic[dados.current.info.historic.length - 1]

									if (aux?.aproval?.id === '' || (aux?.aproval?.date !== undefined && aux?.aproval?.date === '')) {
										dados.current.info.historic[dados.current.info.historic.length - 1].edit.id = aux_responsable[0].id
										dados.current.info.historic[dados.current.info.historic.length - 1].edit.name = aux_responsable[0].label
										dados.current.info.historic[dados.current.info.historic.length - 1].edit.date = today
									}
									else {
										dados.current.info.historic.push({
											edit: {
												id: aux_responsable[0].id,
												name: aux_responsable[0].label,
												date: today
											},
											aproval: {
												id: '',
												name: '',
												date: ''
											}
										})

										dados.current.info.settings.document_state = "1"

										// dados.current.info.responsable.aproval.id = ''
										// dados.current.info.responsable.aproval.name = ''
										// dados.current.info.responsable.aproval.notification = ''
										// dados.current.info.responsable.aproval.execution = ''
									}
								}
							}
						}

						if (notify_responsable_aproval) {
							if (dados.current.info.responsable.aproval.id !== '') {
								let aux_id = dados.current.info.responsable.aproval.id
								let aux_responsable = entities_list.current.filter(e => parseInt(e.id) === parseInt(aux_id))

								dados.current.info.responsable.aproval.notification = today

								if (Array.isArray(dados.current.info.historic) && dados.current.info.historic.length > 0) {
									let aux = dados.current.info.historic[dados.current.info.historic.length - 1]

									dados.current.info.historic[dados.current.info.historic.length - 1].aproval.id = aux_responsable[0].id
									dados.current.info.historic[dados.current.info.historic.length - 1].aproval.name = aux_responsable[0].label
									dados.current.info.historic[dados.current.info.historic.length - 1].aproval.date = ''

								}
							}
						}

						if (notify_responsable_remove) {
							if (dados.current.info.responsable.remove.id !== '') {

								dados.current.info.responsable.remove.notification = today
								dados.current.info.responsable.remove.execution = today

							}

						}

						for await (let el_doc of files_doc_pdf) {
							if (el_doc !== null) {
								await uploadFilesDoc(el_doc.files, el_doc.order, 'pdf', el_doc.langid, el_doc.lang)
							}
						}
						set_files_doc_pdf([])
						set_files_doc_pdf_name([])

						for await (let el_doc of files_doc_editable) {
							if (el_doc !== null) {
								await uploadFilesDoc(el_doc.files, el_doc.order, 'editable', el_doc.langid, el_doc.lang)
							}
						}
						set_files_doc_editable([])
						set_files_doc_editable_name([])

						for await (let el_doc of files_doc_image) {
							if (el_doc !== null) {
								await uploadFilesDoc(el_doc.files, el_doc.order, 'file_image', el_doc.langid, el_doc.lang)
							}
						}
						set_files_doc_image([])
						set_files_doc_image_name([])

						reqPOST(api_crud_route, dados.current)
							.then(() => {
								props.history.push(endpoints.list)
							})
							.catch(() => Swal.fire(language[lang].insert_error, '', 'info'))
					}
				})

		}

		set_dados(dados.current,)
	}

	function apagar() {
		Swal.fire({
			title: language[lang].delete_title,
			text: language[lang].delete_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].delete_confirm,
			cancelButtonText: language[lang].delete_cancel
		})
			.then((result) => {
				if (result.isConfirmed) {
					reqDELETE(api_crud_route, { id: dados.current.id })
						.then(() => {
							props.history.push(endpoints.list);
						})
						.catch(error => console.log(error))
				}
			})
			.catch((erro) => {
				console.log(erro)
			})

	};

	const handle_change_info = (e) => {
		const { name, value, dataset } = e.target;
		const { lang } = dataset

		if (name === 'name' && 0) {
			let value_aux = {}
			let aux = dados.current.info.name.filter(e => e[lang])
			if (aux !== undefined && aux.length === 0) {
				value_aux[lang] = value
				dados.current.info.name.push(value_aux)
			}
			else {
				dados.current.info.name.forEach(el => {
					if (el[lang] !== undefined) {
						el[lang] = value
					}
				})
			}
		}

		if (name === 'external_intervention') {
			setExternalIntervention(value);
		}

		dados.current.info[name] = value

		console.log('«««««««««««««««««««««««')
		console.log('Dados Current:' + JSON.stringify(dados))


	}

	const handle_change_info_translate = (e) => {
		const { name, value, dataset } = e.target;
		const { lang, langid } = dataset

		if (dados.current.info[name] === undefined) {
			dados.current.info[name] = []
		}

		let value_aux = {}
		let aux = dados.current.info[name].filter(e => e[lang])
		if (aux !== undefined && aux.length === 0) {
			value_aux[lang] = value
			dados.current.info[name].push(value_aux)
		}
		else {
			dados.current.info[name].forEach(el => {
				if (el[lang] !== undefined) {
					el[lang] = value
				}
			})
		}

		if (name === 'title' && parseInt(langid) === 1) {
			dados.current.info.name = value
		}

		console.log('«««««««««««««««««««««««')
		console.log('Dados Current:' + JSON.stringify(dados))

	}

	const handleSingleCheckActive = () => {
		set_dados(dados.current.info.active = !dados.current.info.active)
	}

	const handleSingleCheckAvaiable = () => {
		console.log('dados.current.info', dados.current.info)
		set_dados(dados.current.info.avaiable = !dados.current.info.avaiable)
	}

	const handleSingleCheckAproval = () => {

		set_document_state_aprove(!document_state_aprove)

	}

	const change_active_settings = (e) => {
		const { name, value } = e.target;

		if (dados.current.info.settings === undefined) {
			dados.current.info.settings = {}
		}

		set_dados(dados.current.info.settings[name] = value)

		const parsedValue = parseInt(value, 10);

		if (parsedValue === 13) {
			setManutencao(true);
		} else if (parsedValue === 12) {
			setManutencao(false);
		}

	}

	const change_active_responsable = (e) => {
		const { name, value } = e.target;

		if (dados.current.info.responsable === undefined) {
			dados.current.info.responsable = {}
		}

		if (name === 'edit') {
			set_notify_responsable_edit(true)
		}
		else if (name === 'aproval') {
			set_notify_responsable_aproval(true)
		}
		else if (name === 'remove') {
			set_notify_responsable_remove(true)
		}

		let aux_entity = entities_list.current.filter(el => parseInt(el.id) === parseInt(value))
		let aux = {
			id: value,
			name: '',
			notification: '',
			execution: ''
		}
		if (Array.isArray(aux_entity) && aux_entity.length > 0) {
			console.log(aux_entity[0])
			aux.name = aux_entity[0].label
		}

		set_dados(dados.current.info.responsable[name] = aux)

		console.log('dados.current.info.responsable', dados.current.info.responsable)

	}

	const open_link = (url) => {
		window.open(url, '_blank');
	}

	const copy_clipboard = (url) => {
		navigator.clipboard.writeText(url)

		Swal.fire({
			icon: '',
			title: '',
			text: 'Copiado',
			showConfirmButton: false,
			timer: 1000
		})
	}

	const handle_change_tree_editable = (tD, order, langid) => {

		treeDataEditable[order][langid] = tD

		let aux = []
		treeDataEditable[order][langid].forEach((el) => {
			dados.current.info.file.editable.forEach((el_2) => {
				if (el.id_doc === el_2.id)
					aux.push(el_2)
			})
		});
		set_dados(dados.current.info.file.editable = aux)
		setTreeDataEditable(treeDataEditable)

		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current:' + JSON.stringify(dados))
	}

	const remove_element_tree_editable = (order, langid, id, doc) => {

		Swal.fire({
			title: language[lang].delete_title,
			text: language[lang].delete_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].delete_confirm,
			cancelButtonText: language[lang].delete_cancel
		})
			.then((result) => {
				if (result.isConfirmed) {

					let treeAux = treeDataEditable[order][langid].filter(v => v.id !== id)
					treeDataEditable[order][langid] = treeAux
					setTreeDataEditable(treeDataEditable)

					let aux = []
					dados.current.info.file.editable.forEach((el) => {
						if (el.id !== doc)
							aux.push(el)
					})
					set_dados(dados.current.info.file.editable = aux)

				}
			})

		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current:' + JSON.stringify(dados))
	}

	const edit_element_tree_editable = (e) => {
		const { value, dataset } = e.target;
		const { order, id, /*doc,*/ link } = dataset

		treeDataEditable[order].forEach((child) => {
			child.forEach((el) => {
				if (el.id === id) {
					el.title = value

					dados.current.info.file.editable.forEach((el_2) => {
						if (el_2.link === link) {
							el_2.name = value
						}
					})
				}
			})
		})
		setTreeDataEditable(treeDataEditable)
		set_dados(dados.current.info,)
	}

	const onChangeHandlerFilesEditable = (e) => {
		const { files, dataset } = e.target;
		const { order, langid, lang } = dataset

		let storedFiles = [];
		let filesArray = Array.prototype.slice.call(files);

		filesArray.forEach(async (v) => {
			if ((v.size < 10485760)) {
				storedFiles.push(v);

				let aux2 = files_doc_editable_name
				if (aux2[langid] === undefined)
					aux2[langid] = []
				aux2[langid].push({ name: v.name, size: v.size })
				set_files_doc_editable_name(aux2)

				let aux_doc = treeDataEditable
				if (treeDataEditable[order] === undefined)
					treeDataEditable[order] = []
				if (treeDataEditable[order][langid] === undefined)
					treeDataEditable[order][langid] = []
				let i = treeDataEditable[order][langid].length
				aux_doc[order][langid].push({ id: ++i, id_doc: '', title: v.name, link: v.link, visible: true })
				setTreeDataEditable(aux_doc)

				set_dados(dados.current,)
				setRefresh(refresh + 1)
			}
			else {
				alert(language[lang].upload_file_error + v.name);
			}
		});

		let files_aux = files_doc_editable
		files_aux.push({ files: storedFiles, order: order, lang: lang, langid: langid })
		set_files_doc_editable(files_aux)
	}

	const handle_change_tree_pdf = (tD, order, langid) => {

		treeDataPDF[order][langid] = tD

		let aux = []
		if (langid === '1') {
			treeDataPDF[order][langid].forEach((el) => {
				dados.current.content[order].media.doc.forEach((el_2) => {
					if (el.id_doc === el_2.id)
						aux.push(el_2)
				})
			});
			set_dados(dados.current.content[order].media.doc = aux)
			setTreeDataPDF(treeDataPDF)
		}
		else {
			treeDataPDF[order][langid].forEach((el) => {
				dados.current.content[order]['language'][langid].media.doc.forEach((el_2) => {
					if (el.id_doc === el_2.id)
						aux.push(el_2)
				})
			});
			set_dados(dados.current.content[order]['language'][langid].media.doc = aux)
			setTreeDataPDF(treeDataPDF)
		}

		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current:' + JSON.stringify(dados))
	}

	const remove_element_tree_pdf = (order, langid, id, doc) => {

		Swal.fire({
			title: language[lang].delete_title,
			text: language[lang].delete_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].delete_confirm,
			cancelButtonText: language[lang].delete_cancel
		})
			.then((result) => {
				if (result.isConfirmed) {

					let treeAux = treeDataPDF[order][langid].filter(v => v.id !== id)
					treeDataPDF[order][langid] = treeAux
					setTreeDataPDF(treeDataPDF)

					let aux = []
					if (langid === '1') {
						dados.current.content[order].media.doc.forEach((el) => {
							if (el.id !== doc)
								aux.push(el)
						})
						set_dados(dados.current.content[order].media.doc = aux)
					}
					else {
						dados.current.content[order]['language'][langid].media.doc.forEach((el) => {
							if (el.id !== doc)
								aux.push(el)
						})
						set_dados(dados.current.content[order]['language'][langid].media.doc = aux)
					}

				}
			})

		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current:' + JSON.stringify(dados))
	}

	const edit_element_tree_pdf = (e) => {
		const { value, dataset } = e.target;
		const { order, id, /*doc,*/ link } = dataset

		treeDataPDF[order].forEach((child) => {
			child.forEach((el) => {
				if (el.id === id) {
					el.title = value

					dados.current.content[order].media.doc.forEach((el_2) => {
						if (el_2.link === link) {
							el_2.name = value
						}
					})
				}
			})
		})
		setTreeDataPDF(treeDataPDF)
		set_dados(dados.current.content[order],)
	}

	const onChangeHandlerFilesPDF = (e) => {
		const { files, dataset } = e.target;
		const { order, langid, lang } = dataset

		let storedFiles = [];
		let filesArray = Array.prototype.slice.call(files);

		filesArray.forEach(async (v) => {
			if ((v.type.includes('/pdf')) && (v.size < 10485760)) {
				storedFiles.push(v);

				let aux2 = files_doc_pdf_name
				if (aux2[langid] === undefined)
					aux2[langid] = []
				aux2[langid].push({ name: v.name, size: v.size })
				set_files_doc_pdf_name(aux2)

				let aux_doc = treeDataPDF
				if (treeDataPDF[order] === undefined)
					treeDataPDF[order] = []
				if (treeDataPDF[order][langid] === undefined)
					treeDataPDF[order][langid] = []
				let i = treeDataPDF[order][langid].length
				aux_doc[order][langid].push({ id: ++i, id_doc: '', title: v.name, link: v.link, visible: true })
				setTreeDataPDF(aux_doc)

				set_dados(dados.current,)
				setRefresh(refresh + 1)
			}
			else {
				alert(language[lang].upload_file_error + v.name);
			}
		});

		let files_aux = files_doc_pdf
		files_aux.push({ files: storedFiles, order: order, lang: lang, langid: langid })
		set_files_doc_pdf(files_aux)
	}

	const uploadFilesDoc = async (files, order, type, langid, lang) => {
		let aux = []
		for await (let element of files) {
			aux.push(element)

			await uploadFile(element, order, type, langid, lang)
		}
	}

	const uploadFile = async (file, order, type, langid, lang) => {
		const formData = new FormData()
		formData.append('files', file)
		formData.append('id', dados.current.id)
		formData.append('file_name', file.name)
		formData.append('type', 'maintenance')
		formData.append('companycode', dados.current.info.companycode)
		formData.append('uniqid', dados.current.info.uniqid)
		formData.append('folder', Hosts.APP_REPO_FOLDER + 'upload/maintenance/');

		let res = await reqFILE(`${api_crud_base}/multimedia/file`, formData)

		var today_file = new Date()
		let i = Date.now()

		if (dados.current.info.file === undefined) {
			dados.current.info.file = {}
		}
		if (!Array.isArray(dados.current.info.file[type])) {
			dados.current.info.file[type] = []
		}

		if (type === 'editable') {
			dados.current.info.file[type].push({
				id: i,
				link: res.data.path + '/' + res.data.name,
				name: file.name,
				description: '',
				type: type,
				date: today_file,
				order: dados.current.info.file[type].length,
				lang: []
			})
		}
		else if (type === 'pdf') {
			dados.current.info.file[type].push({
				id: i,
				link: res.data.path + '/' + res.data.name,
				name: file.name,
				description: '',
				type: type,
				date: today_file,
				order: dados.current.info.file[type].length,
				lang: []
			})
		}
		else if (type === 'file_image') {
			dados.current.info.file[type].push({
				id: i,
				link: res.data.path + '/' + res.data.name,
				name: file.name,
				description: '',
				type: type,
				date: today_file,
				order: dados.current.info.file[type].length,
				lang: []
			})
		}

		await reqPUT(api_crud_route, dados.current)

		return true

	}

	const handle_change_tree_image = (tD, order, langid) => {

		treeDataImage[order][langid] = tD

		let aux = []
		treeDataImage[order][langid].forEach((el) => {
			dados.current.info.file.image.forEach((el_2) => {
				if (el.id_doc === el_2.id)
					aux.push(el_2)
			})
		});
		set_dados(dados.current.info.file.image = aux)
		setTreeDataImage(treeDataImage)

		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current:' + JSON.stringify(dados))
	}

	const remove_element_tree_image = (order, langid, id, doc) => {

		Swal.fire({
			title: language[lang].delete_title,
			text: language[lang].delete_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].delete_confirm,
			cancelButtonText: language[lang].delete_cancel
		})
			.then((result) => {
				if (result.isConfirmed) {

					let treeAux = treeDataImage[order][langid].filter(v => v.id !== id)
					treeDataImage[order][langid] = treeAux
					setTreeDataImage(treeDataImage)

					let aux = []
					dados.current.info.file.image.forEach((el) => {
						if (el.id !== doc)
							aux.push(el)
					})
					set_dados(dados.current.info.file.image = aux)

				}
			})

		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current:' + JSON.stringify(dados))
	}

	const edit_element_tree_image = (e) => {
		const { value, dataset } = e.target;
		const { order, id, /*doc,*/ link } = dataset

		treeDataImage[order].forEach((child) => {
			child.forEach((el) => {
				if (el.id === id) {
					el.title = value

					dados.current.info.file.image.forEach((el_2) => {
						if (el_2.link === link) {
							el_2.name = value
						}
					})
				}
			})
		})
		setTreeDataImage(treeDataImage)
		set_dados(dados.current.info,)
	}

	const onChangeHandlerFilesFileImage = (e) => {
		const { files, dataset } = e.target;
		const { order, langid, lang } = dataset

		let storedFiles = [];
		let filesArray = Array.prototype.slice.call(files);

		filesArray.forEach(async (v) => {
			if ((v.size < 10485760)) {
				storedFiles.push(v);

				let aux2 = files_doc_image_name
				if (aux2[langid] === undefined)
					aux2[langid] = []
				aux2[langid].push({ name: v.name, size: v.size })
				set_files_doc_image_name(aux2)

				let aux_doc = treeDataImage
				if (treeDataImage[order] === undefined)
					treeDataImage[order] = []
				if (treeDataImage[order][langid] === undefined)
					treeDataImage[order][langid] = []
				let i = treeDataImage[order][langid].length
				aux_doc[order][langid].push({ id: ++i, id_doc: '', title: v.name, link: v.link, visible: true })
				setTreeDataImage(aux_doc)

				set_dados(dados.current,)
				setRefresh(refresh + 1)
			}
			else {
				alert(language[lang].upload_file_error + v.name);
			}
		});

		let files_aux = files_doc_image
		files_aux.push({ files: storedFiles, order: order, lang: lang, langid: langid })
		set_files_doc_image(files_aux)
	}

	useEffect(() => {
		if (dados?.current?.info?.external_intervention !== undefined && dados?.current?.info?.external_intervention !== null) {
			setExternalIntervention(dados.current.info.external_intervention);
		}
	}, [dados]);

	return isloading ?
		<Loader />
		:
		isRedirect
			?
			<Redirect to={endpoints.list} replace />
			:
			<main>
				<div className={`dash-cards header`}>
					<div className="container">
						<h2 className="dash-title">{language[lang].component}</h2>
						<p>{language[lang].component} / {dados.current.id !== '' ? language[lang].component_edit : language[lang].component_new}</p>
					</div>
				</div>

				<div className={`dash-cards body`}>
					<div className="container">
						<div className="row">
							<div className="mb-5 mb-xl-10">
								<div className='card'>
									<div className="card-header border-0 d-flex justify-content-sm-between">
										{/*
										<div className="card-title m-0">
											<h3 className="fw-bolder m-0">{dados.current.info.name.length > 0 ? dados.current.info.name : language[lang].component_new}</h3>
										</div>
										*/}
										<div className="card-toolbar">
											<ul className="nav nav-tabs nav-line-tabs nav-stretch fs-6 border-0">
												{
													content_language.length > 1 ?
														content_language.map((el_lang, k_lang) => {
															return (
																<li key={k_lang} className="nav-item d-none">
																	<a className={"btn btn-sm btn-secondary rounded-0 multi-item" + (k_lang === 0 ? " active" : "")} data-bs-toggle="tab" href={"#tab_pane_info_language_" + k_lang}>{el_lang.code}</a>
																</li>
															)
														})
														:
														null
												}
											</ul>
										</div>
									</div>

									<div id="div-content">
										<form id="form" onSubmit={handleSubmit}>
											<div className="card-body">
												<div className='tab-content'>
													{
														content_language.length > 0 ?
															content_language.filter(Boolean).map((el_lang, k_lang) => {
																return (
																	<div key={el_lang?.id ?? k_lang} className={"tab-pane" + (k_lang === 0 ? " show active" : '')} id={"tab_pane_info_language_" + k_lang} role="tabpanel">
																		<div className="row mb-4">
																			<div className="col-md-12">
																				{selectedEquipment?.info?.equipment && (
																					<div className="border rounded p-4 bg-light shadow-sm">
																						<h6 className="fw-bold mb-4 text-primary">🔍 {language[lang].field_details}</h6>

																						{/* Equipment Info */}
																						<div className="mb-3">
																							<p><strong>{language[lang].field_id}:</strong> {selectedEquipment.id}</p>
																							<p><strong>{language[lang].field_id_ativo}:</strong> {selectedEquipment.info.equipment.id}</p>
																							<p><strong>{language[lang].field_label}:</strong> {selectedEquipment.info.equipment.name}</p>
																							<p><strong>{language[lang].field_cod}:</strong> {selectedEquipment.info.equipment.cod}</p>
																							<p><strong>{language[lang].field_brand}:</strong> {selectedEquipment.info.equipment.brand}</p>
																							<p><strong>{language[lang].field_model}:</strong> {selectedEquipment.info.equipment.model}</p>
																							<p><strong>{language[lang].field_serie}:</strong> {selectedEquipment.info.equipment.serie}</p>
																							<p><strong>{language[lang].field_local}:</strong> {selectedEquipment.info.equipment.local}</p>
																						</div>

																						< br />

																						{/* Actions */}
																						{selectedEquipment.info.action?.length > 0 && (
																							<div className="mt-3">
																								<h6 className="fw-bold text-secondary border-bottom pb-2">👤 {language[lang].field_responsibles}</h6>
																								<ul className="list-unstyled">
																									{selectedEquipment.info.action.map((act, index) => (
																										<li key={`action-${index}`} className="bg-white rounded p-3 mb-2 border">
																											<div><strong>{language[lang].field_responsable}:</strong> {act?.responsavel?.name}</div>
																											<div><strong>{language[lang].data_inicio}:</strong> {act?.data_inicio}</div>
																											<div><strong>{language[lang].data_fim}:</strong> {act?.deadline}</div>
																											<div><strong>{language[lang].field_cost}:</strong> <span className="text-success fw-semibold">{act?.cost || '0.00'}€</span></div>
																										</li>
																									))}
																								</ul>
																								<div className="text-end pe-2">
																									<strong>{language[lang].total_sub_cost}: </strong>
																									<span className="text-success fw-bold">
																										{selectedEquipment.info.action.reduce((acc, act) => acc + parseCost(act?.cost), 0).toFixed(2)}€
																									</span>
																								</div>
																							</div>
																						)}

																						< br />

																						{/* Services */}
																						{selectedEquipment.info.service?.length > 0 && (
																							<div className="mt-4">
																								<h6 className="fw-bold text-secondary border-bottom pb-2">🔧 {language[lang].field_services}</h6>
																								<ul className="list-unstyled">
																									{selectedEquipment.info.service.map((serv, index) => (
																										<li key={`service-${index}`} className="bg-white rounded p-3 mb-2 border">
																											<div><strong>{language[lang].field_service}:</strong> {serv?.service}</div>
																											<div><strong>{language[lang].field_description}:</strong> {serv?.description}</div>
																											<div><strong>{language[lang].field_cost}:</strong> <span className="text-success fw-semibold">{serv?.cost || '0.00'}€</span></div>
																											<div><strong>{language[lang].field_provider}:</strong> {serv?.fornecedor?.name}</div>
																										</li>
																									))}
																								</ul>
																								<div className="text-end pe-2">
																									<strong>{language[lang].total_sub_cost}: </strong>
																									<span className="text-success fw-bold">
																										{selectedEquipment.info.service.reduce((acc, serv) => acc + parseCost(serv?.cost), 0).toFixed(2)}€
																									</span>
																								</div>
																							</div>
																						)}

																						< br />

																						{/* Utilities */}
																						{selectedEquipment.info.utilities?.length > 0 && (
																							<div className="mt-4">
																								<h6 className="fw-bold text-secondary border-bottom pb-2">📦 {language[lang].field_utilities}</h6>
																								<ul className="list-unstyled">
																									{selectedEquipment.info.utilities.map((util, index) => (
																										<li key={`utility-${index}`} className="bg-white rounded p-3 mb-2 border">
																											<div><strong>{language[lang].field_code}:</strong> {util?.code || '000000'}</div>
																											<div><strong>{language[lang].field_description}:</strong> {util?.description}</div>
																											<div><strong>{language[lang].field_quantity}:</strong> {util?.quantity || 1}</div>
																											<div><strong>{language[lang].field_cost}:</strong> <span className="text-success fw-semibold">{util?.cost || '0.00'}€</span></div>
																											<div><strong>{language[lang].field_provider}:</strong> {util?.fornecedor?.name}</div>
																										</li>
																									))}
																								</ul>
																								<div className="text-end pe-2">
																									<strong>{language[lang].total_sub_cost}: </strong>
																									<span className="text-success fw-bold">
																										{selectedEquipment.info.utilities.reduce((acc, util) => acc + parseCost(util?.cost), 0).toFixed(2)}€
																									</span>
																								</div>
																							</div>
																						)}

																						< br />

																						{/* Grand Total */}
																						{(selectedEquipment.info.action?.length > 0 ||
																							selectedEquipment.info.service?.length > 0 ||
																							selectedEquipment.info.utilities?.length > 0) && (
																								<div className="text-end mt-4 border-top pt-3">
																									<strong>{language[lang].total_cost}: </strong>
																									<span className="fw-bold fs-5 text-success">
																										{[
																											...(selectedEquipment.info.action || []),
																											...(selectedEquipment.info.service || []),
																											...(selectedEquipment.info.utilities || [])
																										].reduce((acc, item) => acc + parseCost(item?.cost), 0).toFixed(2)}€
																									</span>
																								</div>
																							)}
																					</div>
																				)}
																			</div>
																		</div>
																	</div>
																)
															})
															:
															null
													}
												</div>
											</div>
										</form>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div className={'dash-cards footer'}>
					<nav className="navbar bottom-navbar navbar-light">
						<div className="navbar-footer">
							<ul className="navbar-nav float-left"></ul>
							<ul className="navbar-nav float-right">
								<li className="nav-item">
									<Link className="nav-link btn-cancel" to={{ pathname: endpoints.list }}  >
										<i className="bi bi-chevron-left me-2"></i>
										<span>{language[lang].back}</span>
									</Link>
								</li>
								{/* 
								<li className={"nav-item " + show_delete_button}>
									<button type="button" onClick={() => apagar(dados.current.id)} className="nav-link btn-delete">
										<i className="bi bi-trash3 me-2"></i>
										<span>{language[lang].delete}</span>
									</button>
								</li>
								<li className="nav-item">
									<button type="submit" form="form" className="nav-link">
										<i className="bi bi-floppy me-2"></i>
										<span>{language[lang].save}</span>
									</button>
								</li>
								*/}
							</ul>
						</div>
					</nav>
				</div>
			</main>
}
